// extracted by mini-css-extract-plugin
module.exports = {"separator":"NextSection_separator__UIM3d","darkSeparator":"NextSection_darkSeparator__oQhNw"};